var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      staticClass: "fullWidthCardRes h-fit",
      attrs: { disabled: false, footerPadding: "px-0" },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col w-full items-center bg-white border-t border-gray-200 adjustFlexWidth",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex gap-1 w-full skills-footer items-start items-center px-4",
                    },
                    [
                      _vm._v(" Skills: "),
                      _vm.skills.length > 0
                        ? _c(
                            "div",
                            { staticClass: "flex flex-row gap-1 items-center" },
                            [
                              _vm._l(_vm.skills.slice(0, 3), function (skill) {
                                return _c(
                                  "div",
                                  {
                                    key: skill.skill.name,
                                    staticClass: "skills-chip",
                                  },
                                  [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                                )
                              }),
                              _vm.skills.length > 3
                                ? _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "skills-chip-plus" },
                                      [
                                        _vm._v(
                                          "+" + _vm._s(_vm.skills.length - 3)
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.skills.length === 0 || _vm.skills === undefined
                        ? _c("div", [_vm._v("n/a")])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "flex flex-col w-full p-4 pb-0" }, [
        _c("div", { staticClass: "flex flex-row justify-between pb-2" }, [
          _c(
            "div",
            { staticClass: "flex flex-col" },
            [
              _c("ManagerAccessActions", {
                attrs: {
                  companyName: _vm.company.business_name,
                  companyId: _vm.company.id,
                  contractorUserId: _vm.marketplaceUser.id,
                  currentUserId: _vm.currentUser.id,
                  contractorId: _vm.contractorId,
                  managerId: _vm.currentUser.manager.id,
                  isRequestContractorShown: _vm.isRequestContractorShown,
                  isContractorRequested: _vm.isContractorRequested,
                },
                on: {
                  cardDataUpdated: function ($event) {
                    return _vm.$emit("cardDataUpdated")
                  },
                },
              }),
              _vm.isAccessGranted
                ? _c("Badge", {
                    staticClass: "text-badge capitalize",
                    attrs: {
                      color: _vm.BadgeColor.ACTIVE,
                      value: "Access granted",
                      styleClasses: "h-auto py-0.5 px-2",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-row gap-2 items-flex-start" },
            [
              _c("RouterLink", { attrs: { to: _vm.publicPageRouteParams } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex transform hover:text-purple-500",
                    on: {
                      mouseover: function ($event) {
                        _vm.isHoveredView = true
                      },
                      mouseout: function ($event) {
                        _vm.isHoveredView = false
                      },
                    },
                  },
                  [
                    !_vm.isHoveredView
                      ? _c("ViewIcon", { staticClass: "w-4 h-4" })
                      : _vm._e(),
                    _vm.isHoveredView
                      ? _c("ViewIconHover", { staticClass: "w-4 h-4" })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "button",
                {
                  staticClass: "h-4",
                  on: {
                    click: _vm.message,
                    mouseover: function ($event) {
                      _vm.isHovered = true
                    },
                    mouseout: function ($event) {
                      _vm.isHovered = false
                    },
                  },
                },
                [
                  !_vm.isHovered
                    ? _c("ChatIcon", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                  _vm.isHovered
                    ? _c("ChatIconHover", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "flex w-full justify-center h-fit mt-2" },
          [
            _c("ResourceAvatar", {
              staticClass: "cursor-pointer text-primary-600",
              attrs: { image: _vm.managerAvatar, initial: _vm.managerInitials },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex items-center justify-center pt-2" },
          [
            _c(
              "RouterLink",
              {
                staticClass: "mr-[40px]",
                attrs: { to: _vm.publicPageRouteParams },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "font-normal text-lg text-default-500 hover:text-primary-500 flex flex-row blueText items-center cursor-pointer gap-2 wMin",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-row text-center nameBlue" },
                      [
                        _c("StatusChip", {
                          staticClass: "mr-2",
                          attrs: { status: _vm.status },
                        }),
                        _vm._v(" " + _vm._s(_vm.contractorFullName) + " "),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flag-wrapper" },
                      [
                        _vm.country
                          ? _c("country-flag", {
                              staticClass: "country-flag",
                              attrs: { country: _vm.country, size: "small" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "flex flex-row justify-center text-default-500 text-sm font-normal customLineH items-center text-center",
          },
          [
            _c("p", { staticClass: "minHeightName leading-4 textWrap" }, [
              _vm._v(" " + _vm._s(_vm.userJobTitle) + " "),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "flex flex-row justify-center items-center" },
          [
            _c("p", { staticClass: "text-sm font-normal grayColor" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.marketplaceUser?.contracts[0]?.tag?.name
                      ? _vm.marketplaceUser?.contracts[0]?.tag?.name
                      : "n/a"
                  ) +
                  " "
              ),
            ]),
            _vm.isAccessGranted
              ? _c("EmployeeTag", {
                  staticClass: "ml-2",
                  attrs: {
                    fullName: _vm.contractorFullName,
                    initials: _vm.initials,
                    avatar: _vm.avatar,
                    contractorId: _vm.marketplaceUser.contracts[0].id,
                    appliedTag: _vm.appliedTag,
                    iconClass: "customIconWidth",
                    userUpdatedDate: _vm.marketplaceUser.updated_at,
                    defaultTagHidden: "",
                  },
                  on: {
                    tagUpdated: function ($event) {
                      return _vm.$emit("cardDataUpdated")
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "flex justify-center text-default-grey text-sm font-medium text-center minHeightName customLineH",
          },
          [_vm._v(" " + _vm._s(_vm.managerLocation) + " ")]
        ),
        _c("div", { staticClass: "action-section mt-2 mb-4" }, [
          _c(
            "div",
            {
              staticClass:
                "relative flex flex-row p-1 customHeightSkill items-center customHeightSkillRate",
            },
            [
              _c("div", { staticClass: "flex flex-col items-center w-full" }, [
                _c("div", { staticClass: "rate-value flex flex-col" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.contractorMinRate) +
                        _vm._s(_vm.contractorMaxRate)
                    ),
                  ]),
                  _vm.contractorMinRate && _vm.contractorMaxRate
                    ? _c("p", [
                        _vm._v(" " + _vm._s(_vm.contractorRateUnit) + " "),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "rate-name" }, [_vm._v("Rate")]),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }